// import { useEffect, useRef, useState } from "react";

// const L = (...a) => console.log("[OURBIT SPOT]", ...a);

// const DEFAULT_PROXY = null;
// const SPOT_DEPTH_URL = (sym) =>
//   `https://www.ourbit.com/api/platform/spot/market/depth?symbol=${sym}`;

// // "ETHUSDT" | "ETH_USDT" | "eth-usdt" -> "ETH_USDT"
// function toOurbitSpotSymbol(input) {
//   const s = String(input || "").toUpperCase().replace(/[-]/g, "_");
//   if (!s) return null;
//   if (/_USDT$/.test(s)) return s;
//   const m = s.match(/^([A-Z0-9]+)USDT$/);
//   if (m) return `${m[1]}_USDT`;
//   return `${s}_USDT`;
// }

// // Ourbit SPOT depth -> data: { asks:[{p,q}...], bids:[{p,q}...] }
// function normalizeSide(side) {
//   if (!Array.isArray(side)) return [];
//   if (side.length === 0) return [];
//   // поддержим и массивы [[p,q],...] и объекты {p,q}
//   if (Array.isArray(side[0])) return side.map(([p, q]) => [String(p), String(q)]);
//   return side.map((row) => [String(row?.p), String(row?.q)]);
// }

// function normalizeDepth(payload) {
//   // у Ourbit: { code:200, data: { symbol, symbolDisplay, data:{ asks:[], bids:[] }, version } }
//   const root = payload?.data ?? payload;
//   const d =
//     root?.data  // <- нужный вложенный объект
//     ?? root?.result
//     ?? root;

//   const asks = normalizeSide(d?.asks ?? d?.Asks ?? d?.sell ?? d?.a);
//   const bids = normalizeSide(d?.bids ?? d?.Bids ?? d?.buy  ?? d?.b);

//   return { asks, bids };
// }

// export function useOurbitSpot(symbol, {
//   pollIntervalMs = 1000,
//   proxy = DEFAULT_PROXY,
//   depthLimit = 50,
// } = {}) {
//   const [orderBook, setOrderBook]   = useState({ asks: [], bids: [] });
//   const [tickerData, setTickerData] = useState(null);
//   const [error, setError]           = useState(null);
//   const [isConnected, setIsConnected] = useState(false);

//   const timerRef = useRef(null);

//   useEffect(() => {
//     const sym = toOurbitSpotSymbol(symbol);
//     if (!sym) {
//       setOrderBook({ asks: [], bids: [] });
//       setTickerData(null);
//       setIsConnected(false);
//       setError(null);
//       return;
//     }

//     let cancelled = false;

//     const fetchOnce = async () => {
//       const url = SPOT_DEPTH_URL(sym);
//       const finalUrl = proxy ? `${proxy}/${url}` : url;

//       L("fetch depth", { sym, url: finalUrl });
//       const res = await fetch(finalUrl, { headers: { 'ngrok-skip-browser-warning': '1' } });
//       if (!res.ok) throw new Error(`Ourbit SPOT depth HTTP ${res.status}`);
//       const json = await res.json();

//       const { asks, bids } = normalizeDepth(json);
//       const A = depthLimit ? asks.slice(0, depthLimit) : asks;
//       const B = depthLimit ? bids.slice(0, depthLimit) : bids;

//       setOrderBook({ asks: A, bids: B });

//       // поставим простейший lastPrice по mid
//       const a = A?.[0]?.[0] ? Number(A[0][0]) : null;
//       const b = B?.[0]?.[0] ? Number(B[0][0]) : null;
//       const mid = (a != null && b != null) ? (a + b) / 2 : null;
//       setTickerData(mid != null ? { lastPrice: String(mid) } : null);

//       setError(null);
//       setIsConnected(true);
//     };

//     const start = async () => {
//       try {
//         await fetchOnce();
//       } catch (e) {
//         L("init error", e?.message || e);
//         setError(e?.message || String(e));
//         setIsConnected(false);
//       }
//       if (cancelled) return;

//       timerRef.current = setInterval(async () => {
//         try {
//           await fetchOnce();
//         } catch (e) {
//           L("poll error", e?.message || e);
//           setIsConnected(false);
//           setError(e?.message || String(e));
//         }
//       }, pollIntervalMs);
//     };

//     start();

//     return () => {
//       cancelled = true;
//       if (timerRef.current) clearInterval(timerRef.current);
//       timerRef.current = null;
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [symbol, pollIntervalMs, proxy, depthLimit]);

//   return { isConnected, error, orderBook, tickerData };
// }

// export default useOurbitSpot;
import { useEffect, useRef, useState } from "react";

const L = (...a) => console.log("[OURBIT SPOT]", ...a);

// ✅ дефолтно ходим через твой бек-прокси
const DEFAULT_PROXY = `${process.env.REACT_APP_BACKEND_URL || ""}/proxy`;
const SPOT_DEPTH_URL = (sym) =>
  `https://www.ourbit.com/api/platform/spot/market/depth?symbol=${encodeURIComponent(sym)}`;

// ✅ Умный конструктор, как и в фьючерсах
function viaProxy(proxy, absUrl) {
  if (!proxy) return absUrl;
  const p = proxy.replace(/\/+$/,"");
  const a = String(absUrl);
  if (a.includes("/proxy/")) return a;
  try {
    const pURL = new URL(p);
    const aURL = new URL(a);
    if (aURL.host === pURL.host && aURL.pathname.includes("/proxy/")) return a;
  } catch {}
  return `${p}/${a}`;
}

// "ETHUSDT" | "ETH_USDT" | "eth-usdt" -> "ETH_USDT"
function toOurbitSpotSymbol(input) {
  const s = String(input || "").trim().toUpperCase().replace(/[-]/g, "_");
  if (!s) return null;
  if (/_USDT$/.test(s)) return s;
  const m = s.match(/^([A-Z0-9]+)USDT$/);
  if (m) return `${m[1]}_USDT`;
  return `${s}_USDT`;
}

// Ourbit SPOT depth -> data: { asks:[{p,q}...], bids:[{p,q}...] }
function normalizeSide(side) {
  if (!Array.isArray(side) || !side.length) return [];
  if (Array.isArray(side[0])) return side.map(([p, q]) => [String(p), String(q)]);
  return side.map((row) => [
    String(row?.p ?? row?.price ?? row?.Price),
    String(row?.q ?? row?.qty ?? row?.volume ?? row?.Volume),
  ]);
}

function normalizeDepth(payload) {
  const root = payload?.data ?? payload?.result ?? payload;
  const d =
    root?.data && (root.data.asks || root.data.bids) ? root.data :
    root?.data?.data && (root.data.data.asks || root.data.data.bids) ? root.data.data :
    root;

  const asks = normalizeSide(d?.asks ?? d?.Asks ?? d?.sell ?? d?.a);
  const bids = normalizeSide(d?.bids ?? d?.Bids ?? d?.buy  ?? d?.b);
  return { asks, bids };
}

export function useOurbitSpot(symbol, {
  pollIntervalMs = 1000,
  proxy = DEFAULT_PROXY,        // ✅ дефолт — через твой прокси
  depthLimit = 50,
} = {}) {
  const [orderBook, setOrderBook]     = useState({ asks: [], bids: [] });
  const [tickerData, setTickerData]   = useState(null);
  const [error, setError]             = useState(null);
  const [isConnected, setIsConnected] = useState(false);

  const timerRef = useRef(null);

  useEffect(() => {
    const sym = toOurbitSpotSymbol(symbol);
    if (!sym) {
      setOrderBook({ asks: [], bids: [] });
      setTickerData(null);
      setIsConnected(false);
      setError(null);
      return;
    }

    let cancelled = false;

    const fetchOnce = async () => {
      const rawUrl = SPOT_DEPTH_URL(sym);
      const finalUrl = viaProxy(proxy, rawUrl);

      L("GET depth:", finalUrl);
      const res = await fetch(finalUrl, { headers: { "ngrok-skip-browser-warning": "1" } });
      if (!res.ok) throw new Error(`Ourbit SPOT depth HTTP ${res.status}`);
      const json = await res.json();

      const { asks, bids } = normalizeDepth(json);
      const A = depthLimit ? asks.slice(0, depthLimit) : asks;
      const B = depthLimit ? bids.slice(0, depthLimit) : bids;

      setOrderBook({ asks: A, bids: B });

      // простейший lastPrice по mid
      const a = A?.[0]?.[0] ? Number(A[0][0]) : null;
      const b = B?.[0]?.[0] ? Number(B[0][0]) : null;
      const mid = (a != null && b != null) ? (a + b) / 2 : (a ?? b ?? null);
      setTickerData(mid != null ? { lastPrice: String(mid) } : null);

      setError(null);
      setIsConnected(true);
    };

    const start = async () => {
      try {
        await fetchOnce();
      } catch (e) {
        L("init error", e?.message || e);
        setError(e?.message || String(e));
        setIsConnected(false);
      }
      if (cancelled) return;

      timerRef.current = setInterval(async () => {
        try { await fetchOnce(); }
        catch (e) {
          L("poll error", e?.message || e);
          setIsConnected(false);
          setError(e?.message || String(e));
        }
      }, pollIntervalMs);
    };

    start();

    return () => {
      cancelled = true;
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = null;
    };
  }, [symbol, pollIntervalMs, proxy, depthLimit]);

  return { isConnected, error, orderBook, tickerData };
}

export default useOurbitSpot;
